import { makeAspectCrop } from "react-image-crop";

export type CropPresetId = "original" | "1:1" | "4:3" | "3:4" | "16:9" | "9:16";

export const CROP_PRESETS: Array<{
  id: CropPresetId;
  label: string;
  aspect: number | null;
}> = [
  { id: "original", label: "Original", aspect: null },
  { id: "1:1", label: "Square", aspect: 1 },
  { id: "4:3", label: "4:3", aspect: 4 / 3 },
  { id: "3:4", label: "3:4", aspect: 3 / 4 },
  { id: "16:9", label: "16:9", aspect: 16 / 9 },
  { id: "9:16", label: "9:16", aspect: 9 / 16 },
];

export function cropForPreset(
  presetId: CropPresetId,
  image: HTMLImageElement
): { x: number; y: number; width: number; height: number; aspect?: number } {
  const preset = CROP_PRESETS.find(p => p.id === presetId);
  const imageAspect = image.naturalWidth / image.naturalHeight;

  if (!preset || preset.aspect == null) {
    return { x: 0, y: 0, width: 100, height: 100 };
  }

  const crop = makeAspectCrop(
    {
      x: 0,
      y: 0,
      aspect: preset.aspect,
      width: 90,
    },
    imageAspect
  );

  crop.x = (100 - crop.width) / 2;
  crop.y = (100 - crop.height) / 2;
  return crop;
}

export function scaleCropDimensions(
  sourceWidth: number,
  sourceHeight: number,
  maxSize: number
): { width: number; height: number } {
  if (sourceWidth <= maxSize && sourceHeight <= maxSize) {
    return { width: sourceWidth, height: sourceHeight };
  }
  const scale = maxSize / Math.max(sourceWidth, sourceHeight);
  return {
    width: Math.round(sourceWidth * scale),
    height: Math.round(sourceHeight * scale),
  };
}

export function presetIconClass(
  presetId: CropPresetId,
  styles: Record<string, string>
): string {
  switch (presetId) {
    case "original":
      return styles.aspectIconOriginal;
    case "1:1":
      return styles.aspectIconSquare;
    case "4:3":
      return styles.aspectIcon4x3;
    case "3:4":
      return styles.aspectIcon3x4;
    case "16:9":
      return styles.aspectIcon16x9;
    case "9:16":
      return styles.aspectIcon9x16;
    default:
      return styles.aspectIconOriginal;
  }
}
